import React, { useContext } from "react"
import {
  Row,
  Card,
  CardBody,
} from "reactstrap"
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import { AttendanceContext } from "context/attendanceContext"
import { useNavigate } from "react-router-dom"

const ReportLeftSidebar = () => {
  const {
    classListOption,
    handleclassselect,
    selectedDate,
    handleDateChange,
    classSelect,
  } = useContext(AttendanceContext)

  const navigate = useNavigate()

  return (
    <>
      <Card>
        <CardBody className="p-3">
          <Row className="mb-0">
            <div className="col-sm-12">
              <select
                value={classSelect}
                className="form-select"
                type="select"
                name="class"
                onChange={e => {
                  handleclassselect(e)
                  navigate("/attendance")
                }}
              >
                <option value="" style={{ fontWeight: "bold" }}>
                  Select Class
                </option>
                {classListOption?.map((class1, index) => (
                  <option key={index} value={class1.label}>
                    {class1.label.toUpperCase()}
                  </option>
                ))}
              </select>
            </div>
          </Row>
        </CardBody>
      </Card>
      <Card>
        <CardBody className="p-3">
          <div className="form-group mb-0">
            <h4 className="card-title mb-2  text-start">Select Date</h4>
            <Flatpickr
              className="form-control d-block"
              placeholder="dd M,yyyy"
              value={selectedDate}
              onChange={handleDateChange}
              options={{
                inline: true,
                dateFormat: 'd M Y',
                maxDate: new Date(),
              }}
            />
          </div>
        </CardBody>
      </Card>
    </>
  )
}

export default ReportLeftSidebar
